export enum AdminMessages {
	UPLOAD_USIGNALE_ERROR = 'Fehler in Zeile {1}: {2}',
	ASK_TO_DELETE_USIGNAL = 'Wollen Sie das U-Signal {usignal} wirklich löschen?',
}
